import { NewsletterSignup } from './newsletter-signup';
import { NewsletterSignupFooter } from './newsletter-signup-footer';

export { NewsletterSignup, NewsletterSignupFooter };
